import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";

function Dua({ queue, setQueue, setCurrent, setPlaying, liked, setLiked }) {
  const [duaaData, setDuaaData] = useState(null);
  const [duaa, setDuaa] = useState([]);
  const { duaaSlug } = useParams();

  useEffect(() => {
    fetch(baseUrl + `api/v1/dua/${duaaSlug}`)
      .then((res) => res.json())
      .then((data) => {
        setDuaaData(data);
        setDuaa(Array.isArray(data.audio) ? data.audio : []);
      })
      .catch(() => {
        setDuaaData(null);
        setDuaa([]);
      });
  }, [duaaSlug]);

  const normalizeAudio = (dua, duaaData) => ({
    id: dua.id,
    title: duaaData.title,
    reciter: duaaData.reciter,
    riwaya: duaaData.riwaya,
    cover: `${duaaData.image}`,
    src: `${dua.path}`,
  });

  const playAudio = (dua) => {
    const normalized = normalizeAudio(dua, duaaData);

    // Copy queue and find index
    let newQueue = [...queue];
    let index = newQueue.findIndex((s) => s.id === normalized.id);

    if (index === -1) {
      newQueue.push(normalized);
      index = newQueue.length - 1;
    }

    setQueue(newQueue);
    setCurrent(index);
    setPlaying(true);
  };

  const toggleLike = (dua) => {
    const normalized = normalizeAudio(dua, duaaData);

    let newLiked;
    if (liked.includes(normalized.id)) {
      newLiked = liked.filter((id) => id !== normalized.id);
    } else {
      newLiked = [...liked, normalized.id];

      // Add to queue if not present
      if (!queue.find((q) => q.id === normalized.id)) {
        setQueue([...queue, normalized]);
      }
    }

    setLiked(newLiked);
    localStorage.setItem("likedAudioList", JSON.stringify(newLiked));
  };

  const playDuaa = () => {
    const normalizedAudioList = duaa.map((s) => normalizeAudio(s, duaaData));

    // Merge new audio list into queue without duplicates
    const newQueue = [...queue];
    normalizedAudioList.forEach((s) => {
      if (!newQueue.find((q) => q.id === s.id)) newQueue.push(s);
    });

    setQueue(newQueue);

    // Start with first narration audio index in the updated queue
    const firstIndex = newQueue.findIndex(
      (q) => q.id === normalizedAudioList[0].id,
    );
    setCurrent(firstIndex);
    setPlaying(true);
  };

  if (!duaaData) {
    return (
      <div className="narration-audio-list">
        <p>Loading duaa...</p>
      </div>
    );
  }

  return (
    <div className="narration-audio-list">
      <div className="narration-hero">
        <img
          className="narration-hero-image"
          src={`${duaaData.image}`}
          alt={duaaData.reciter}
        />

        <div className="narration-hero-info">
          <h1 className="narration-title">{duaaData.reciter}</h1>
          <div className="narration-meta">
            <span className="reciter-name">{duaaData.riwaya}</span>
          </div>

          <button className="play-all-btn" onClick={playDuaa}>
            ▶ Play All
          </button>
        </div>
      </div>

      <table className="list-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Play / ❤️</th>
          </tr>
        </thead>
        <tbody>
          {duaa.map((dua, index) => (
            <tr key={dua.id}>
              <td>{index + 1}</td>
              <td>{duaaData.title}</td>
              <td>
                <button onClick={() => playAudio(dua)}>▶</button>

                <span className="liked">
                  <button onClick={() => toggleLike(dua)}>
                    {liked.includes(dua.id) ? "❤️" : "🤍"}
                  </button>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Dua;
